import type { DreamitySnapshot } from '@/types/dreamitySnapshot.types'

/** 서버 pull 등으로 로컬 스냅샷 파일이 통째로 바뀐 뒤 — 컨텍스트가 메모리 상태를 디스크와 맞출 때 사용 */
export const DREAMITY_LOCAL_SNAPSHOT_REPLACED_EVENT = 'dreamity:local-snapshot-replaced'
import {
  DREAMITY_SNAPSHOT_SCHEMA_VERSION,
  normalizePlannerSnapshot,
} from '@/types/dreamitySnapshot.types'
import { getDreamitySnapshotStorageKey } from '@/utils/storageKeys'
import { getFieldFromToken } from '@/utils/jwt'

export function createEmptyDreamitySnapshot(): DreamitySnapshot {
  return {
    meta: {
      schemaVersion: DREAMITY_SNAPSHOT_SCHEMA_VERSION,
      dirty: false,
    },
    domains: {},
  }
}

export function getSnapshotUserIdFromToken(): string | null {
  if (typeof window === 'undefined') return null
  const token = localStorage.getItem('token')
  if (!token) return null
  const uid = getFieldFromToken(token, 'userId')
  if (uid == null) return null
  return String(uid)
}

export function readLocalDreamitySnapshot(userId: string): DreamitySnapshot | null {
  try {
    const raw = localStorage.getItem(getDreamitySnapshotStorageKey(userId))
    if (!raw) return null
    const parsed = JSON.parse(raw) as unknown
    return normalizePlannerSnapshot(parsed)
  } catch {
    return null
  }
}

export function writeLocalDreamitySnapshot(userId: string, snapshot: DreamitySnapshot): void {
  try {
    localStorage.setItem(getDreamitySnapshotStorageKey(userId), JSON.stringify(snapshot))
  } catch (e) {
    console.warn('[DreamitySnapshot] localStorage write failed:', e)
  }
}

export function replaceLocalDreamitySnapshotFromServer(
  userId: string,
  snapshot: DreamitySnapshot,
  serverUpdatedAtIso: string
): void {
  const normalized = normalizePlannerSnapshot(snapshot)
  if (!normalized) {
    console.warn('[DreamitySnapshot] replace: invalid snapshot, skip')
    return
  }
  normalized.meta.dirty = false
  normalized.meta.lastKnownServerUpdatedAt = serverUpdatedAtIso
  writeLocalDreamitySnapshot(userId, normalized)
  try {
    window.dispatchEvent(new Event(DREAMITY_LOCAL_SNAPSHOT_REPLACED_EVENT))
  } catch {
    /* ignore */
  }
}
